import React from 'react';
import ColumnVisibilityMenu, { type ColumnVisibilityItem } from './ColumnVisibilityMenu';

export type DataTableToolbarProps = {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  onRefresh?: () => void;
  onExportCsv?: () => void;
  rightSlot?: React.ReactNode;
  columnsMenu?: {
    columns: ColumnVisibilityItem[];
    onToggle: (id: string) => void;
    onReset: () => void;
  };
};

export default function DataTableToolbar({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search…',
  onRefresh,
  onExportCsv,
  rightSlot,
  columnsMenu,
}: DataTableToolbarProps) {
  const showSearch = onSearchChange != null;
  const showActions = onRefresh || onExportCsv || columnsMenu || rightSlot;

  if (!showSearch && !showActions) return null;

  return (
    <div className="data-table-toolbar">
      {showSearch && (
        <div className="data-table-toolbar__search">
          <input
            type="search"
            className="data-table-toolbar__search-input"
            value={searchValue ?? ''}
            placeholder={searchPlaceholder}
            aria-label="Search table"
            onChange={(e) => onSearchChange?.(e.target.value)}
          />
        </div>
      )}
      <div className="data-table-toolbar__actions">
        {onRefresh && (
          <button type="button" className="btn btn-sm btn-ghost" onClick={onRefresh}>
            Refresh
          </button>
        )}
        {onExportCsv && (
          <button type="button" className="btn btn-sm btn-ghost" onClick={onExportCsv}>
            Export CSV
          </button>
        )}
        {columnsMenu && (
          <ColumnVisibilityMenu
            columns={columnsMenu.columns}
            onToggle={columnsMenu.onToggle}
            onReset={columnsMenu.onReset}
          />
        )}
        {rightSlot}
      </div>
    </div>
  );
}
